import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import classes from "./WordGameDetails.module.css";
import { FaArrowLeft } from "react-icons/fa6";

import { resetIndex } from "../store/slices/wordGameSlice/activeTileSlice";
import { resetTiles } from "../store/slices/wordGameSlice/tileWordSlice";
import { resetEnteredWords } from "../store/slices/wordGameSlice/enteredWordSlice";
import { resetTargetWord } from "../store/slices/wordGameSlice/targetWordSlice";
import { resetTargetWord3 } from "../store/slices/wordGameSlice/targetWord3Slice";
import { resetWord3Result } from "../store/slices/wordGameSlice/word3Result";
import { resetWordResult } from "../store/slices/wordGameSlice/wordResult";
import { ResetTime, ResetTimeForProgress } from "../store/slices/wordGameSlice/wordTimeSlice";
import { useDispatch } from 'react-redux';

const WordGameDetails = () => {
    const navigate = useNavigate();
    const dispatch=useDispatch();
    
    const [level, setLevel] = useState("1");
    return (
        <>

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate(-1);
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                </div>


                <div className={classes.quiz_image_container}>
                    {/* <div className={classes.quiz_image_wrapper}> */}
                        <img
                            src={"/assets/images/guess-word.png"}
                            alt={"word game"} className={classes.quiz_image} />
                    {/* </div> */}
                </div>

                <p className={classes.quiz_title}>
                    Guess the Word Game
                </p>

                {/* <div className={classes.quiz_questions_container}>
                    <div className={classes.question_image_icon_container}>
                        <img src='/assets/images/question.png' alt={t("9")} className={classes.question_image_icon} />
                    </div>
                    <p className={classes.question_text}>{quizLevel?.questions} {t("9")}</p>
                </div> */}

                <div className={classes.quiz_description_container}>

                    {/* <p className={classes.quiz_description_title}>

                    </p> */}

                    <p className={classes.quiz_description}>
                        A word game is a fun and engaging activity where players use letters or words to solve puzzles. This  games test vocabulary, spelling, and quick thinking.
                    </p>
                </div>

                <div className={classes.quiz_description_container}>

                    <p className={classes.quiz_description_title}>
                        Choose Level
                    </p>

                    <div className={classes.levels_container}>
                        <div className={`${classes.level_container} ${level == "1" && classes.beginner_active}`}
                            onClick={() => {
                                setLevel(1)
                            }}
                        >
                            <div className={classes.level_sub_container}>
                                <div className={classes.level_info}>
                                    <img src="/assets/images/Beginner.png" alt="beginner level" className={classes.level_img} />
                                    <p className={classes.level_text}>Beginner</p>
                                </div>
                                {/* <div className={`${classes.points_badge} ${classes.beginner}`}>
                                    <p className={classes.points}>50 {t("13")}</p>
                                </div> */}
                            </div>
                        </div>

                        <div className={`${classes.level_container} ${level == "2" && classes.intermediate_active}`}
                            onClick={() => {
                                setLevel(2)
                            }}
                        >
                            <div className={classes.level_sub_container}>
                                <div className={classes.level_info}>
                                    <img src="/assets/images/Intermediate.png" alt="intermediate level" className={classes.level_img} />
                                    <p className={classes.level_text}>Intermediate</p>
                                </div>
                                {/* <div className={`${classes.points_badge} ${classes.intermediate}`}>
                                    <p className={classes.points}>80 {t("13")}</p>
                                </div> */}
                            </div>
                        </div>

                        <div className={`${classes.level_container} ${level == "3" && classes.advance_active}`}
                            onClick={() => {
                                setLevel(3)
                            }}
                        >
                            <div className={classes.level_sub_container}>
                                <div className={classes.level_info}>
                                    <img src="/assets/images/Advance.png" alt="advance level" className={classes.level_img} />
                                    <p className={classes.level_text}>Advance</p>
                                </div>
                                {/* <div className={`${classes.points_badge} ${classes.advance}`}>
                                    <p className={classes.points}>100 {t("13")}</p>
                                </div> */}
                            </div>
                        </div>

                    </div>

                </div>

                <button className={`${classes.play_button}`} type='button'
                    onClick={() => {

                        dispatch(resetIndex());
                        dispatch(resetTiles());
                        dispatch(resetEnteredWords());
                        dispatch(resetTargetWord());
                        dispatch(resetTargetWord3());
                        dispatch(resetWord3Result());
                        dispatch(resetWordResult());
                        dispatch(ResetTime());
                        dispatch(ResetTimeForProgress());

                        navigate("/word-game", {
                            state: {
                                level: level
                            }
                        })
                    }}
                >
                    Play
                </button>



            </div >

        </>
    )
}

export default WordGameDetails